/* eslint-disable react/prop-types */
import React, { useRef } from 'react'
import { useFormPageHandler } from 'irmlib/hooks'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { TextField } from 'irmlib/components/FormControls'
import PropTypes from 'prop-types'
import { YDivider } from 'irmlib/styles'
import { useTranslation } from 'react-i18next'
import { OutlinedButton, ContainedButton, Label } from 'irmlib/components/Controls'
import { Grid } from '@material-ui/core'
import { errorToast } from '../../../common/functions'

const EXCEPTION_NOTE = 0

const formTemplate = [
  {
    label: 'smartCatalog.exceptionNote',
    fieldKey: 'exceptionNote',
    isRequired: true,
  },
]

const getService = async (setState) => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

const VerticalDivider = () => <YDivider height="20px" />

export const ActivityExceptionModal = (props) => {
  const { showModal, showExceptionModal, showExceptionModalFor, getExceptionData } = props
  const { t } = useTranslation()
  const refLocalBusyCursor = useRef(null)
  const [open, setOpen] = React.useState(showModal)

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  const handleClose = () => {
    setOpen(false)
    showExceptionModal(false)
  }

  const addExceptionNote = async() => {
    if (!arrRefs[EXCEPTION_NOTE]?.current?.getValue() || arrRefs[EXCEPTION_NOTE]?.current?.getValue().trim() === '') {
      errorToast({ message: t('smartCatalog.exceptionNoteRequired'), title: t('toast.error') })
    } else {
      getExceptionData({
        exceptionFor: showExceptionModalFor,
        exceptionNote: arrRefs[EXCEPTION_NOTE]?.current?.getValue() || '',
      })
      setOpen(false)
      showExceptionModal(false)
    }
  }

  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth='xs'>
        <DialogTitle>{showExceptionModalFor === 'Image Exception' ? t('smartCatalog.imgException') : t('smartCatalog.boxException')}</DialogTitle>
        <DialogContent>
          <>
            <VerticalDivider />
            <Label style = {{ minWidth: '350px' }}></Label>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField 
                  id={'createActivity_orderNumber'} 
                  data={data} 
                  fieldTemplate={formTemplate[EXCEPTION_NOTE]} 
                  ref={arrRefs[EXCEPTION_NOTE]} 
                  style={{ marginBottom: '20px' }}
                />
              </Grid>
            </Grid>
          </>
        </DialogContent>
        <DialogActions sx={{ pb: 2, pr: 2 }}>
          <OutlinedButton 
            style={{ width: '90px', height: '36.5px', margin: '5px' }}
            onClick={handleClose}
          >
            buttons.cancel
          </OutlinedButton>
          <ContainedButton 
            style={{ width: '90px', height: '36.5px', margin: '5px' }}
            onClick={addExceptionNote}
          >
            buttons.save
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

ActivityExceptionModal.propTypes = {
  showModal: PropTypes.bool,
  showExceptionModal: PropTypes.func,
  getExceptionData: PropTypes.func,
}